import type { DeleteApprovalMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteApprovalDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteApproval = createMutationHook({
  name: 'deleteApproval',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.approval.delete.mutationOptions({ onSuccess }),
  mapInput: (variables: { Id: string }) => ({ Id: variables.Id }),
  invalidate: (trpc) => [
    trpc.frontend.approval.globalApprovals.queryKey(),
    trpc.frontend.approval.approvalLevels.queryKey(),
  ],
  mapResponse: (result: { affected_rows: number }): DeleteApprovalMutation => ({
    delete_approval: {
      __typename: 'approval_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: DeleteApprovalDocument,
  graphqlVariables: (variables: { Id: string }) => ({ Id: variables.Id }),
  // `getGlobalApprovals` reads the `approval` root field and `getApprovalLevels`
  // reads `approval_level`; evict both so the Apollo (flag-off) path refreshes
  // both feeds (mirrors the tRPC branch's `invalidate`).
  evictFields: ['approval', 'approval_level'],
});
